// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require(63);

$export($export.P + $export.R, 'Map', { toJSON: require(53)('Map') });
